<template>
  <div class='mainContainer'>
    <div class='nav'>
      <el-form :model='searchForm' label-width='130px' :inline='true'>
        <el-form-item label='供应商：'>
          <el-input v-model='searchForm.supplierName' size='mini' placeholder='请输入供应商' />
        </el-form-item>
        <el-form-item label='对账单标题：'>
          <el-input v-model='searchForm.title' size='mini' placeholder='请输入对账单标题' />
        </el-form-item>
        <el-form-item label='发票号码：'>
          <el-input v-model='searchForm.invoiceNo' size='mini' placeholder='请输入发票号码' />
        </el-form-item>
        <el-form-item label='发票日期：'>
          <el-date-picker
            size='mini'
            v-model='invoiceDate'
            value-format='yyyy-MM-dd'
            type='daterange'
            unlink-panels
            range-separator='至'
            start-placeholder='开始日期'
            end-placeholder='结束日期'
            :picker-options='pickerOptions'>
          </el-date-picker>
        </el-form-item>
        <el-form-item label='应付日期：'>
          <el-date-picker
            size='mini'
            v-model='shouldDate'
            value-format='yyyy-MM-dd'
            type='daterange'
            unlink-panels
            range-separator='至'
            start-placeholder='开始日期'
            end-placeholder='结束日期'
            :picker-options='pickerOptions'>
          </el-date-picker>
        </el-form-item>
        <el-form-item label='是否核销:'>
          <el-select v-model='searchForm.isCheck' size='mini' placeholder='请选择是否核销'>
            <el-option label='全部' value='' />
            <el-option label='是' :value='1' />
            <el-option label='否' :value='0' />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size='small' style='margin-left: 10px;' class='searchBtn' @click='searchBtn'>
            查询
          </el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
          <el-button size='small' type='primary' @click='btnClick("setUpDays")'>设置天数</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span='24' class='exportButton'>
        <span @click='exportData'>导出数据</span>
      </el-col>
    </el-row>
    <div class='content'>
      <el-table
        ref='registerTable'
        row-key='id'
        v-loading='tableLoading'
        :data='tableData'
        style='width: 100%'
        border
        :header-cell-style='headerCellStyle'
        :span-method='objectSpanMethod'>
        <el-table-column label='供应商' prop='supplierName' align='center' />
        <el-table-column label='对账单标题' prop='title' align='center' />
        <el-table-column label='发票号码' prop='invoiceNo' align='center' width='200' />
        <el-table-column label='发票日期' prop='invoiceDate' align='center' />
        <el-table-column label='发票金额' prop='taxPrice' align='center' />
        <el-table-column label='应付日期' prop='shouldDate' align='center' />
        <el-table-column label='是否核销' prop='isCheck' align='center'
                         :formatter='isCheckFormat' />
        <el-table-column label='备注' prop='remark' align='center' />
      </el-table>
      <div class='paginationContainer'>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='searchForm.page'
          :page-size='searchForm.rows'
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';
  import { receiptList } from '@/service/receipt';
  import { getDays, setDays, supplierReportList } from '@/service/financial';

  export default {
    name: 'payment',
    data() {
      return {
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          }],
        },
        invoiceDate: ['', ''],
        shouldDate: ['', ''],
        searchForm: {
          supplierName: '',
          title: '',
          invoiceNo: '',
          isCheck: '',
          page: 1,
          rows: 10,
        },
        defaultSearchForm: {},
        tableLoading: false,
        tableData: [],
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
        total: 0,
        selectedData: [],
      };
    },
    mounted() {
      this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
      // this.searchBtn();
    },
    methods: {
      // 合并相同列
      objectSpanMethod({
                         row,
                         column,
                         rowIndex,
                         columnIndex,
                       }) {
        // data ：需要修改的列数和列的属性 第一列从0开始
        const data = [
          {
            columnIndex: 0,
            value: 'supplierName',
          },
          {
            columnIndex: 1,
            value: 'title',
          },
        ];
        for (let index = 0; index < data.length; index++) {
          if (columnIndex === data[index].columnIndex) {
            const _row = this.filterData(this.tableData, data[index].value)[rowIndex];
            const _col = _row > 0 ? 1 : 0;
            return {
              rowspan: _row,
              colspan: _col,
            };
          }
        }
      },
      // 根据是否有相同数据返回一个如[2,0,3,0,0]格式的数组(公共的)
      filterData(arr, value) {
        let spanOneArr = [];
        let concatOne = 0;
        arr.forEach((item, index) => {
          if (index === 0) {
            spanOneArr.push(1);
          } else {
            // name 修改
            if (item[value] === arr[index - 1][value]) {
              spanOneArr[concatOne] += 1;
              spanOneArr.push(0);
            } else {
              spanOneArr.push(1);
              concatOne = index;
            }
          }
        });
        return spanOneArr;
      },
      btnClick(str) {
        switch (str) {
          case 'setUpDays':
            this.setUpDays();
            break;
        }
      },
      async setUpDays() {
        const {
          status,
          message,
          data,
        } = await getDays({ type: 2 });
        if (status !== 0) return this.$message.warning(message);
        this.$prompt('设置天数', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputValue: data,
          closeOnClickModal: false,
          closeOnPressEscape: false,
        })
          .then(async ({ value }) => {
            const {
              status,
              message,
            } = await setDays({
              days: value,
              type: 2,
            });
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '取消设置',
            });
          });
      },
      // 状态格式化
      isCheckFormat(row, column, cellValue) {
        switch (cellValue) {
          case 0:
            return '未核销';
          case 1:
            return '已核销';
        }
      },
      // 查询
      searchBtn() {
        this.searchForm.page = 1;
        this.getTableData();
      },
      // 重置
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
        this.invoiceDate = ['', ''];
        this.shouldDate = ['', ''];
      },
      // 获取表格数据
      async getTableData() {
        this.tableLoading = true;
        const {
          status,
          message,
          data,
        } = await supplierReportList({
          ...this.searchForm,
          invoiceStartDate: this.invoiceDate[0] ? this.invoiceDate[0] : '',
          invoiceEndDate: this.invoiceDate[1] ? this.invoiceDate[1] : '',
          shouldStartDate: this.shouldDate[0] ? this.shouldDate[0] : '',
          shouldEndDate: this.shouldDate[1] ? this.shouldDate[1] : '',
        });
        this.tableLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.tableData = data.records;
        this.total = data.total;
      },
      contractSizeChange(row) {
        this.searchForm.rows = row;
        this.searchForm.page = 1;
        this.getTableData();
      },
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getTableData();
      },
      // 导出数据
      exportData() {
        // let token = getSessionStore('token');
        const {
          supplierName,
          title,
          invoiceNo,
          isCheck,
        } = this.searchForm;
        // window.location.href = `${baseUrl}/platform/settlementReport/supplierExportExcel?access_token=${token}&supplierName=${supplierName}&title=${title}&invoiceNo=${invoiceNo}&isCheck=${isCheck}&invoiceStartDate=${this.invoiceDate[0] ? this.invoiceDate[0] : ''}&invoiceEndDate=${this.invoiceDate[1] ? this.invoiceDate[1] : ''}&shouldStartDate=${this.shouldDate[0] ? this.shouldDate[0] : ''}&shouldEndDate=${this.shouldDate[1] ? this.shouldDate[1] : ''}`;
        window.exportExcelGet('/platform/settlementReport/supplierExportExcel', `supplierName=${supplierName}&title=${title}&invoiceNo=${invoiceNo}&isCheck=${isCheck}&invoiceStartDate=${this.invoiceDate[0] ? this.invoiceDate[0] : ''}&invoiceEndDate=${this.invoiceDate[1] ? this.invoiceDate[1] : ''}&shouldStartDate=${this.shouldDate[0] ? this.shouldDate[0] : ''}&shouldEndDate=${this.shouldDate[1] ? this.shouldDate[1] : ''}`)
      },
    },
  };
</script>


<style lang='scss' scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 15px;

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }
    }

    .content {
      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-top: 10px;

        span {
          font-size: 13px;
        }
      }
    }
  }
</style>
